export class StyleOfText
{
   public gameFont: string | string[];;
    constructor()
    {
        this.gameFont="Tahoma, Helvetica, sans-serif"
    }
}